import { Box, Flex } from "@mantine/core";
import { useGetEmbeddedLinkQuery } from "src/generated/graphql";

interface ViewPoliciesProps {
  signedAgreementId: string;
}

const ViewPolicies = ({ signedAgreementId }: ViewPoliciesProps) => {
  const { data: link } = useGetEmbeddedLinkQuery({
    variables: { signedAgreementId: signedAgreementId! },
    skip: !signedAgreementId,
    fetchPolicy: "network-only",
  });

  return (
    <Flex direction={"column"} justify={"space-between"}>
      <Box bg={"white"} w={"90vw"} h={"70vh"}>
        <iframe
          src={link?.getEmbeddedLink || ""}
          height="100%"
          width="100%"
          frameBorder={0}
          style={{ minHeight: "40vh" }}
        ></iframe>
      </Box>
    </Flex>
  );
};

export default ViewPolicies;
